export const HTML_INPUT_TEXT_TYPES = [
  'tel',
  'url',
  'text',
  'date',
  'time',
  'email',
  'number',
  'search',
  'password',
  'datetime-local',
  'textarea',
] as const;

export function isEditingTextTarget(target: EventTarget | null): boolean {
  if (!target || !(target instanceof HTMLElement)) {
    return false;
  }
  const el = target as HTMLElement;
  if (el.tagName === 'TEXTAREA') {
    return true;
  }
  if (el.isContentEditable) {
    return true;
  }
  if (el.tagName === 'INPUT') {
    return HTML_INPUT_TEXT_TYPES.includes(
      (el as HTMLInputElement).type as (typeof HTML_INPUT_TEXT_TYPES)[number]
    );
  }
  return false;
}
